/**
 * Created by ivo on 04.02.17.
 */
import React from 'react';
import _ from 'underscore';
import BaseContainer from '../BaseContainer';
import {NotificationActions, NotificationStore} from '../../services/Notification';
import Notify from './components/Notify';

const propTypes = {};

const defaultProps = {};

const levelPriorities = {
    'debug': 1,
    'info': 2,
    'success': 3,
    'warning': 4,
    'error': 5
};

class NotifyContainer extends BaseContainer {
    constructor(props) {
        super(props, {notification: NotificationStore});
        this.onHide = this.onHide.bind(this);
    }

    onHide(id) {
        NotificationActions.dismiss(id);
    }

    getLevel(info) {
        if (_.has(levelPriorities, info.level)) return levelPriorities[info.level];
        return 0;
    }

    render() {
        let items = _.filter(this.state.notification.data, (item) => (this.getLevel(item) > 1 && item.state === "visible"));
        return (<Notify items={items} onHide={this.onHide}/>);
    }
}

NotifyContainer.propTypes = propTypes;
NotifyContainer.defaultProps = defaultProps;

export default NotifyContainer;
